// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPushProvisionEmailVerificationRequest
 */
export interface IPushProvisionEmailVerificationRequest {
    /**
     * 
     * @type {number}
     * @memberof IPushProvisionEmailVerificationRequest
     */
    card_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPushProvisionEmailVerificationRequest
     */
    code: string;
}

/**
 * Check if a given object implements the IPushProvisionEmailVerificationRequest interface.
 */
export function instanceOfIPushProvisionEmailVerificationRequest(value: object): value is IPushProvisionEmailVerificationRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function IPushProvisionEmailVerificationRequestFromJSON(json: any): IPushProvisionEmailVerificationRequest {
    return IPushProvisionEmailVerificationRequestFromJSONTyped(json, false);
}

export function IPushProvisionEmailVerificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPushProvisionEmailVerificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'card_id': json['card_id'] == null ? undefined : json['card_id'],
        'code': json['code'],
    };
}

export function IPushProvisionEmailVerificationRequestToJSON(json: any): IPushProvisionEmailVerificationRequest {
    return IPushProvisionEmailVerificationRequestToJSONTyped(json, false);
}

export function IPushProvisionEmailVerificationRequestToJSONTyped(value?: IPushProvisionEmailVerificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_id': value['card_id'],
        'code': value['code'],
    };
}

